module.exports = __webpack_public_path__ + "static/img/spinner.4979b47.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.gif
// module id = 180
// module chunks = 1